<template>
    <component
        :is="$attrs.href ? 'a' : ($attrs.to ? 'router-link' : 'button')"
        class="BaseButton"
        :class="{ 'BaseButton--outlined': outlined, 'BaseButton--primary': primary, 'BaseButton--small': small, 'BaseButton--muted': muted }">
        <slot/>
    </component>
</template>
<script>
    export default {
        name: 'BaseButton',
    	props: {
    		outlined: Boolean,
            primary: Boolean,
            small: Boolean,
            muted: Boolean
        }
    }
</script>

<style lang="scss" scoped>
    .BaseButton {
        background: var(--colorBrandSecondary);
        border: 2px solid var(--colorBrandSecondary);
        color: #fff;
        padding: .8em 1.4em;
        text-decoration: none;
        display: inline-flex;
        align-items: center;
        gap: .6em;
        cursor: pointer;
        outline: 0;
        font-family: inherit;
        font-size: 1em;
        line-height: 1.4;
        transition: all .25s ease-in-out;
        text-transform: uppercase;
        font-weight: 700;
        border-radius: 0;

        &:hover { 
            background: var(--colorBrandSecondaryDarken);
            border-color: var(--colorBrandSecondaryDarken);
        }

        &--primary {
            background: var(--colorBrand);
            border-color: var(--colorBrand);

            &:hover {
                background: var(--colorBrandDarken);
                border-color: var(--colorBrandDarken);
            }
        }

        &--outlined {
            background: transparent;
            color: var(--colorBrandSecondary);

            &:hover {
                color: #fff;
            }
        }

        &--small {
            font-size: .85em;
        }

        &--muted {
            background: transparent;
            color: #aaa;
            border-color: #aaa;
            padding: .9em;

            &:hover {
                border-color: var(--colorBrandSecondary);
                color: var(--colorBrandSecondary);
            }
        }

        &:disabled, &.is-disabled {
            pointer-events: none;
            background: #a4a699;
            border-color: #a4a699;
        }

        :deep(svg) {
            width: 1.2em;
            height: 1.2em;
        }
    }
</style>
